<template>
    <div>
        <p class="modal-heading">Are you sure you want to cancel the test?</p>
        <p v-if="!testExists" class="text-sm">Any progress will not be saved</p>

        <div v-else>
            <label class="mt-2">Reason <span class="text-danger">*</span></label>
            <select @change="reasonTypeError = false" class="custom-select" v-model="reasonType">
                <option value=null disabled selected>Please select an option</option>
                <option :value="CancellationReason.TEST_COMPLETED_IN_CLINIC">Test completed in clinic</option>
                <option :value="CancellationReason.BABY_DELIVERED">Baby delivered</option>
                <option :value="CancellationReason.MISCARRIAGE_STILLBIRTH">Miscarriage / stillbirth</option>
                <option :value="CancellationReason.DUPLICATE">Duplicate test</option>
                <option :value="CancellationReason.PATIENT_MOVED">Patient moved hospital</option>
                <option :value="CancellationReason.INCOMPLETE_FAULTY_TEST">Incomplete / faulty test kit</option>
                <option :value="CancellationReason.VOMITED">Vomited</option>
                <option :value="CancellationReason.SPILLED_THE_DRINK">Spilled the drink</option>
                <option :value="CancellationReason.USED_ALL_LANCETS">Used all the lancets</option>
                <option :value="CancellationReason.UPLOAD_FAILED">Results had not uploaded successfully</option>
                <option :value="CancellationReason.DELIVERED_INCORRECT_ADDRESS">Test delivered to incorrect address</option>
                <option :value="CancellationReason.TEST_DECLINED">Declined to do the test</option>
                <option :value="CancellationReason.STARTED_LATE">Started late</option>
                <option :value="CancellationReason.USER_ERROR">User error</option>
                <option :value="CancellationReason.HCP_ERROR">HCP error</option>
                <option :value="CancellationReason.NEEDLE_PHOBIC">Needle phobic</option>
                <option :value="CancellationReason.OTHER">Other</option>
            </select>
            <p v-if="reasonTypeError" class="text-danger text-xs">This is a required field</p>

            <div v-if="reasonType == CancellationReason.OTHER">
                <label class="mt-2">Note <span class="text-danger">*</span></label>
                <textarea class="form-control note" :class="{ 'border border-danger' : noteError }" placeholder="Tell us the reason for cancelling this test" v-model="note"></textarea>
                <p v-if="noteError" class="text-danger text-xs">This is a required field</p>
            </div>
        </div>

        <div class="d-flex align-items-center mt-45">
            <button :disabled="loading" @click="cancelTest()" class="btn btn-success btn-lg lg-shadow d-flex flex-grow-1 w-50 justify-content-center align-items-center" :class="{disabled : loading}">Yes <span v-if="loading" class="btn-loading"></span></button>
            <button :disabled="loading" @click="close()" class="btn btn-danger btn-lg lg-shadow d-flex flex-grow-1 w-50 ml-3 justify-content-center align-items-center" :class="{disabled : loading}">No</button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import {mapActions} from 'vuex'
import SignalRMixin from '@/mixins/SignalRMixin'
import CancellationReason from '../../../../Common/enums/CancellationReasonType'
export default {
    name: 'CancelTestModalComponent',

    props: {
        testExists: Boolean(false),
        organisationId: String,
        testId: String
    },

    mixins: [
        SignalRMixin
    ],

    data() {
        return {
            loading: false,
            reasonType: null,
            note: null,
            noteError: false,
            reasonTypeError: false,
            CancellationReason
        }
    },

    methods: {
        ...mapActions({
            clearTestStore: 'TestStore/ClearData',
            setNotification: 'NotificationStore/SetNotification',
            setShouldRefreshViewTestComponent: 'AppStore/SetShouldRefreshViewTestComponent',
            setShouldRefreshPatientTestsComponent: 'AppStore/SetShouldRefreshPatientTestsComponent'
        }),

        async cancelTest() {
            this.clearTestStore()
            this.noteError = false
            this.reasonTypeError = false
            this.closeSignalRConnection()

            if(this.testExists) {
                if(this.reasonType == null) {
                    this.reasonTypeError = true
                    return
                }
                if(this.reasonType == CancellationReason.OTHER && (this.note == null || this.note == '')) {
                    this.noteError = true
                    return 
                }

                this.loading = true

                try {
                    await axios.patch(`${process.env.VUE_APP_AXIOS_DIAGNOSTIC_BASE_URL}/api/v1/tests/${this.organisationId}/${this.testId}/cancel`, {
                        reasonType: this.reasonType,
                        reason: this.note
                    })

                    this.setNotification({
                        type: 'success',
                        title: 'Success',
                        message: 'The test has been marked as cancelled'
                    })
                }
                catch {
                    this.setNotification({
                        type: 'error',
                        title: 'Error',
                        message: 'Sorry, something went wrong when cancelling the test. Please try again'
                    })
                }
                finally {
                    this.loading = false
                }
            }
            
            this.$emit('close')
            if(this.$route.name == 'ViewPatient') {
                return this.setShouldRefreshPatientTestsComponent(true)
            }

            if(this.$route.name == 'ViewTest') {
                return this.setShouldRefreshViewTestComponent(true)
            }
            return this.$router.push({name: 'Dashboard'})
        },

        close() {
            this.$emit('close')
        }
    }
}
</script>